<script>
  import Header from "./Header.svelte";
  import Paragraph from "./Paragraph.svelte";
  import Footer from "./Footer.svelte";
  import EpisodeEmbed from "./EpisodeEmbed.svelte";

  export let embedded = false;
  export let episode = null;
</script>

<div class="section">
  <div class="content">
    <div class="header">In Conversation</div>
    <EpisodeEmbed {episode}></EpisodeEmbed>
  </div>
</div>

{#if !embedded}
  <Footer></Footer>
{/if}

<style>
  .section {
    width: 100%;
    max-width: var(--max-width);
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: var(--main-gutter);
    padding-top: var(--main-gutter-vertical);
    padding-bottom: var(--main-gutter-vertical);
    flex-direction: column;
    /* border-bottom: 1px solid black; */
    font-size: 16px;
    /* line-height: 1.5; */
    /* border-bottom: 1px solid black; */
  }
  .content {
    max-width: 800px;
  }

  .header {
    /* font-weight: bold; */
    /* text-transform: uppercase; */
    line-height: 1;
    margin-top: 0px;
    margin-bottom: 20px;
    /* font-size: 16px; */
    font-size: 25px;
    padding-bottom: 0;
  }
</style>
